import { CogIcon, PresentationChartLineIcon } from '@heroicons/react/outline';
import type { ComponentType } from 'react';

export interface NavigationItem {
  label: string;
  href: string;
  Icon: ComponentType<{ className?: string }>;
  isActive?: (pathname: string) => boolean;
  showInMenu?: boolean;
}

export const getNavigationItems = (): NavigationItem[] => [
  {
    label: 'Brand analysis',
    href: '/',
    Icon: PresentationChartLineIcon,
    isActive: (pathname: string) =>
      pathname.startsWith('/setup') || pathname === '/',
    showInMenu: true,
  },
  {
    label: 'Settings',
    href: '/settings',
    Icon: CogIcon,
    isActive: (pathname: string) => pathname.startsWith('/settings'),
    showInMenu: true,
  },
  // {
  //   label: 'Query history',
  //   href: '/query-history',
  //   Icon: ArchiveIcon,
  //   isActive: (pathname: string) => pathname.startsWith('/query-history'),
  //   showInMenu: true,
  // },
];
